import React, { PropTypes } from 'react';
import { orange500, red600, green500 } from 'material-ui/styles/colors';
import AlertWarning from 'material-ui/svg-icons/alert/warning';
import { values } from 'lodash';
import ToggleCheckBox from 'material-ui/svg-icons/action/check-circle';
import { getRegionStats, getRegionSummary } from '../../utils';

import base from '../../styles';
import css from './Regions.css';

const styles = {
  table: {
    width: '100%',
    maxWidth: 1000,
  },
  heading: {
    borderBottom: 'thin solid blue',
  },
  h2: {
    ...base.h2,
    marginTop: 0,
  },
};

const Regions = ({ regions, onRegionClick }) => {
  const summary = getRegionSummary(regions);
  return (
    <div>
      <h2 style={styles.h2} className={css.heading}>Sähköttömät asiakkaat alueittain</h2>
      <table style={styles.table}>
        <thead className={css.thead}>
          <tr>
            <th rowSpan="2">Alue</th>
            <th colSpan="2">Viat</th>
            <th colSpan="2">Työt</th>
            <th rowSpan="2">Sähköttömät asiakkaat</th>
          </tr>
          <tr>
            <th>Kpl</th>
            <th>Asiakkaat</th>
            <th>Kpl</th>
            <th>Asiakkaat</th>
          </tr>
        </thead>
        <tbody className={css.tbody}>
          {values(regions).sort((a, b) => a.name > b.name).map((region) => {
            const stats = getRegionStats(region);
            let icon;
            if (stats.faults.count) {
              icon = <AlertWarning className={css.icon} style={{ fill: red600 }} />;
            } else if (stats.maintenances.count) {
              icon = <AlertWarning className={css.icon} style={{ fill: orange500 }} />;
            } else {
              icon = <ToggleCheckBox className={css.icon} style={{ fill: green500 }} />;
            }
            return (
              <tr key={region.name}>
                <td className={css.regionName} onTouchTap={() => onRegionClick(region)}>
                  {icon}
                  <span className={css.regionNameText}>{region.name}</span>
                </td>
                <td>{stats.faults.count}</td>
                <td>{stats.faults.customers}</td>
                <td>{stats.maintenances.count}</td>
                <td>{stats.maintenances.customers}</td>
                <td>{stats.faults.customers + stats.maintenances.customers}</td>
              </tr>
            );
          })}
          <tr>
            <td className={css.regionName} onTouchTap={() => onRegionClick(null)}>
              <span className={css.summary}>Yhteensä</span>
            </td>
            <td>{summary.faults.count}</td>
            <td>{summary.faults.customers}</td>
            <td>{summary.maintenances.count}</td>
            <td>{summary.maintenances.customers}</td>
            <td>{summary.faults.customers + summary.maintenances.customers}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

Regions.propTypes = {
  regions: PropTypes.object.isRequired,
  onRegionClick: PropTypes.func.isRequired,
};

export default Regions;



// WEBPACK FOOTER //
// ./src/components/Regions/Regions.js